import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { injectIntl } from 'react-intl';

import AdminFileSizesListHeader from './ListHeader';
import AdminFileSizesListItem from './ListItem';
import HelpIcon from '../../HelpIcon';
import EmptyTableCell from '../../EmptyTableCell';

class AdminFileSizesList extends PureComponent {
  render() {
    const {
      intl,
      page,
      sizes,
      timestamp,
      updateSizeOnList,
      deleteSizeFromList,
    } = this.props;

    return (
      <div className="table-wrapper">
        <Table className="users-list sizes-list" responsive>
          <thead>
            <AdminFileSizesListHeader
              {...this.props}
            />
          </thead>
          <tbody>
            {page === 1 && (
              <tr>
                <th scope="row" className="size-name">
                  {intl.formatMessage({ defaultMessage: 'Original size' })}
                  <HelpIcon id="file-size-original">
                    {intl.formatMessage({ defaultMessage: 'This is the original file size that was uploaded. This size cannot be changed.' })}
                  </HelpIcon>
                </th>
                <td className="size-dimension"><EmptyTableCell /></td>
                <td className="size-crop"><EmptyTableCell /></td>
                <td className="action-more" />
              </tr>
            )}
            {sizes.map(size => (
              <AdminFileSizesListItem
                key={size.id}
                size={size}
                timestamp={timestamp}
                updateSizeOnList={updateSizeOnList}
                deleteSizeFromList={deleteSizeFromList}
              />
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

AdminFileSizesList.propTypes = {
  intl: PropTypes.object.isRequired,
  page: PropTypes.number.isRequired,
  sizes: PropTypes.array.isRequired,
  timestamp: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  updateSizeOnList: PropTypes.func.isRequired,
  deleteSizeFromList: PropTypes.func.isRequired,
};

export default injectIntl(AdminFileSizesList);
